import React, { useEffect } from 'react'
import Navbar from '../../components/common/Navbar/Navbar'
import logo from '../../assets/Avothar-black-logo.png'
import bannarImg from '../../assets/banner/about-img.gif'
import Bannar from '../../components/common/Bannar/Bannar'
import Footer from '../../components/common/Footer/Footer'
import poombarai from '../../assets/about/about-us-img.png'
import FounderImg from '../../assets/about/about-us-poombarai.png'
import ripped from '../../assets/farm/ripped-paper-header-1.png'
import AOS from 'aos'

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className='bg-white'>
      <Navbar position="static" logo={logo} color='dark' buttonColor='light' navColor="black" />
      <Bannar img={bannarImg} name="About Us" />
      <section className='container p-5'>
        <h1 className=' about-head text-center pb-4' style={{ fontWeight: 700, wordSpacing: 3, letterSpacing: 2 }}>Why Choose Avothar</h1>
        <div className='row'>
          <div className='col-lg-3'>
            <div className="elementor-icon-box-icon text-center h2">
              <span className="elementor-icon elementor-animation-" style={{ fontWeight: 700, textShadow: '3px 2px 5px rgba(161,205,93,0.6)' }}>
                <i aria-hidden="true" className="fas fa-leaf"></i>
              </span>
            </div>
            <h5 className='text-center pb-4 ' style={{ fontWeight: 600, lineHeight: 2, wordSpacing: 2, letterSpacing: 1 }}>Sustainable Farming Practices</h5>
            <p className='text-center ' style={{ lineHeight: 2, wordSpacing: 2, letterSpacing: 1 }}>We use eco-friendly farming practices that promote soil health and minimize our impact on the environment.</p>
          </div>
          <div className='col-lg-3'>
            <div className="elementor-icon-box-icon text-center h2">
              <span className="elementor-icon elementor-animation-" style={{ fontWeight: 700, textShadow: '3px 2px 5px rgba(161,205,93,0.6)' }}>
                <i aria-hidden="true" class="fas fa-thumbs-up"></i>
              </span>
            </div>
            <h5 className='text-center pb-4' style={{ fontWeight: 600, lineHeight: 2, wordSpacing: 2, letterSpacing: 1 }}>High-Quality Avocados</h5>
            <p className='text-center' style={{ lineHeight: 2, wordSpacing: 2, letterSpacing: 1 }}>Our avocados are grown using sustainable farming practices and are handpicked to ensure that only the best fruit makes it to market.</p>
          </div>
          <div className='col-lg-3'>
            <div className="elementor-icon-box-icon text-center h2">
              <span className="elementor-icon elementor-animation-" style={{ fontWeight: 700, textShadow: '3px 2px 5px rgba(161,205,93,0.6)' }}>
                <i aria-hidden="true" class="fas fa-users"></i>
              </span>
            </div>
            <h5 className='text-center pb-4' style={{ fontWeight: 600, lineHeight: 2, wordSpacing: 2, letterSpacing: 1 }}>Experienced Team</h5>
            <p className='text-center' style={{ lineHeight: 2, wordSpacing: 2, letterSpacing: 1 }}>We're passionate about what we do and our team of experts are committed to helping you succeed as an avocado farmer.</p>
          </div>
          <div className='col-lg-3'>
            <div className="elementor-icon-box-icon text-center h2">
              <span className="elementor-icon elementor-animation-" style={{ fontWeight: 700, textShadow: '3px 2px 5px rgba(161,205,93,0.6)' }}>
                <i aria-hidden="true" class="fas fa-money-bill-wave-alt"></i>
              </span>
            </div>
            <h5 className='text-center pb-4' style={{ fontWeight: 600, lineHeight: 2, wordSpacing: 2, letterSpacing: 1 }}>Generational Wealth</h5>
            <p className='text-center' style={{ lineHeight: 2, wordSpacing: 2, letterSpacing: 1 }}>By owning a piece of farmland in our rich natural environment, you're contributing to a legacy that will last for generations to come.</p>
          </div>
        </div>
      </section>

      <div className='ripped-paper-base' style={{
        backgroundImage: `url(${ripped})`, height: "2.6vh", backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        // transform: "rotate(180deg)",
        width: "100%",
        backgroundSize: "cover",
        position: "relative", bottom: -15, left: 0
      }}></div>
      <section>
        <div className='row tour-image' style={{ backgroundColor: "#000000" }}>
          <div className='col-lg-6 p-0 '  >
            <img src={poombarai} alt="tour-image" className='w-100 h-100' />
          </div>
          <div className='col-lg-6 d-flex justify-content-center align-items-center ' style={{ color: "#ffffff" }}>
            <div className='w-75 p-md-5  py-5' data-aos="fade-up" data-aos-duration="3000">
              <h2 className='banner-font fs-1 '>Own Your Piece of Paradise
                in the Hills of Kodaikanal</h2>
              <p className='' style={{ fontSize: "16px", lineHeight: 2, wordSpacing: 2, letterSpacing: 1 }}>Kodai Agriorg Private Limited is a community-driven avocado plantation in the hills of Kodaikanal. Our mission is to provide sustainable agriculture solutions while supporting local communities. We offer customers the opportunity to invest in farm land and receive a variety of services, including maintenance and farming support. Join us in our journey towards responsible agriculture and enhance your wealth with our avocado plantation.</p>
            </div>
          </div>
        </div>
      </section>
      <div className='ripped-paper-base' style={{
        backgroundImage: `url(${ripped})`, height: "2.6vh", backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        transform: "rotate(180deg)",
        backgroundSize: "cover",
        position: "relative", bottom: 15, left: 0
      }}></div>

      <section className='container p-5'>
          <div className="p-3">
            <h1 className=' about-head text-center pb-4' style={{ fontWeight: 700, wordSpacing: 3, letterSpacing: 2 }}>Our Mission and Vision</h1>
        <div className='row '>
          <div className='col-lg-4 '>
            <h1 className='text-center about-head' style={{ color: "#346029", fontWeight: 600, wordSpacing: 2, letterSpacing: 1, fontSize:"50px" }}>10,000</h1>
            <p className='text-center' style={{ color: "#346029", lineHeight: 2, wordSpacing: 2, letterSpacing: 1 }}>Avocado Trees</p>
            <p className='text-left ' style={{ lineHeight: 2, wordSpacing: 2, letterSpacing: 1 }}>Our vision is to plant 10,000 avocado
              trees across 100 acres of land in Poombarai, Kodaikanal. Join us in promoting sustainable agriculture and fostering a community of avocado enthusiasts.</p>
          </div>
          <div className='col-lg-4'>
            <h1 className='text-center about-head' style={{  fontSize:"50px", color: "#ABA955", fontWeight: 600, wordSpacing: 2, letterSpacing: 1 }}>100</h1>
            <p className='text-center' style={{ color: "#ABA955", lineHeight: 2, wordSpacing: 2, letterSpacing: 1 }}>Acres of Agriculture Land</p>
            <p className='text-left ' style={{ lineHeight: 2, wordSpacing: 2, letterSpacing: 1 }}>we aim to create a flourishing ecosystem that supports the growth of these trees and maximizes their potential. Our team is committed to implementing the latest advancements in technology to ensure the health and productivity of our avocado orchard.</p>
          </div>
          <div className='col-lg-4'>
            <h5 className='text-center about-head d-flex justify-content-between' style={{ color: "#346029", fontWeight: 600, wordSpacing: 2, letterSpacing: 1 }}>Planted Trees <span>20%</span></h5>
            <div className='mt-4' style={{width: "20%", height:"1.5%", backgroundColor:"#346029",  borderTopLeftRadius:"20px", borderBottomLeftRadius:"20px"}}></div>
            <h5 className='text-center about-head d-flex justify-content-between mt-5' style={{ color: "#ABA955", fontWeight: 600, wordSpacing: 2, letterSpacing: 1 }}>Acres Covered <span>20%</span></h5>
            <div className='mt-4' style={{width: "20%", height:"1.5%", backgroundColor:"#ABA955",  borderTopLeftRadius:"20px", borderBottomLeftRadius:"20px"}}></div>
          </div>
        </div>
          </div>
      </section>

      <div className='ripped-paper-base' style={{
        backgroundImage: `url(${ripped})`, height: "2.6vh", backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        // transform: "rotate(180deg)",
        width: "100%",
        backgroundSize: "cover",
        position: "relative", bottom: -15, left: 0
      }}></div>
      <section>
        <div className='row tour-image' style={{ backgroundColor: "#000000" }}>

          <div className='col-lg-6 d-flex justify-content-center align-items-center ' style={{ color: "#ffffff" }}>
            <div className='w-75 p-md-5  py-5' data-aos="fade-up" data-aos-duration="3000">
              <h2 className='banner-font fs-1 '>Founder's Story</h2>
              <p className='pt-2' style={{ fontSize: "16px", lineHeight: 2, wordSpacing: 2, letterSpacing: 1 }}>“AVOTHAR”, powered by Kodai Agriorg, was founded in 2018 by Pyar Mohamed, a tech entrepreneur turned nature enthusiast. With a background in software and business operations, and having travelled across the world, Pyar developed a passion for farming, hiking, eco-projects, and especially avocados.</p>

              <p className='pt-3' style={{ fontSize: "16px", lineHeight: 2, wordSpacing: 2, letterSpacing: 1 }}>During his travels, the scenic village of Poombarai in Kodaikanal left a lasting impact on him. Its climate and landscape inspired the idea of helping urban dwellers own a “Peace of Land” and be part of a sustainable farming ecosystem. He realized that avocado farming could be both ecologically and economically rewarding, while also contributing to local livelihoods.</p>

              <p className='pt-3' style={{ fontSize: "16px", lineHeight: 2, wordSpacing: 2, letterSpacing: 1 }}>Thus, AVOTHAR was born — a brand dedicated to avocado plantations, farm experiences, and community-based agriculture. Today, it brings together nature lovers, investors, and farmers to build a greener, shared future in the hills of Kodaikanal.</p>
            </div>
          </div>

          <div className='col-lg-6 p-0 ' style={{
            backgroundImage: `url('${FounderImg}')`,
            backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundSize: "cover",
          }} >
          </div>
        </div>
      </section>
      <div className='ripped-paper-base' style={{
        backgroundImage: `url(${ripped})`, height: "2.6vh", backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        transform: "rotate(180deg)",
        backgroundSize: "cover",
        position: "relative", bottom: 15, left: 0
      }}></div>
      <Footer />
    </div>
  )
}


export default About